import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';

import { denormalize, normalize } from '../shared/normalizers';

import { Habit } from './_types';

export * from './_types';

export const HabitsQueryKey = ['habits'];

export const fetchHabit = async (habitId: Identifier): Promise<Habit> => {
  const response = await api.get(`/api/v4/habits/${habitId}`);
  return normalize(response.data);
};

export const fetchHabits = async (): Promise<Habit[]> => {
  const response = await api.get('/api/v4/habits?fetch_all=true');
  return response.data.map((habit: any) => normalize(habit));
};

export const createHabit = async (
  habitData: Omit<Habit, 'id'>
): Promise<Habit> => {
  const response = await api.post('/api/v4/habits', denormalize(habitData));
  return normalize(response.data);
};

export const updateHabit = async (habitData: Habit): Promise<Habit> => {
  const { id, ...habitDataWithoutId } = habitData;
  const response = await api.put(
    `/api/v4/habits/${id}`,
    denormalize(habitDataWithoutId)
  );
  return normalize(response.data);
};

export const deleteHabit = async (habitId: Identifier): Promise<void> => {
  await api.delete(`/api/v4/habits/${habitId}`);
};

export const fetchHabitCurrentGoal = async (
  habitId: Identifier,
  userId: Identifier,
  date: string,
  timeZone: string
): Promise<number> => {
  const response = await api.get(`/api/v4/habits/${habitId}/current_goal/`, {
    params: {
      user_id: userId,
      date_string: date,
      time_zone: timeZone,
    },
  });
  return response.data;
};

export const updateHabitGoal = async (
  habitId: Identifier,
  userId: Identifier,
  value: number,
  date: string,
  timeZone: string,
  dateNumber?: number
): Promise<void> => {
  await api.post(`/api/v4/habits/${habitId}/update_goal/`, {
    user_id: userId,
    value,
    date_string: date,
    time_zone: timeZone,
    date: dateNumber,
  });
};
